import { Keyboard, KeyboardResize } from '@capacitor/keyboard'
import { SplashScreen } from '@capacitor/splash-screen'
import { StatusBar, Style } from '@capacitor/status-bar'

import { markLiveUpdateReady } from '../liveUpdate'
import { interceptExternalLinks } from './browser'
import { listenForAppUrlOpen } from './deepLinks'
import { getNativePlatform, isNativePlatform } from './platform'

export async function initNativeShell(): Promise<void> {
  if (!isNativePlatform()) return

  document.documentElement.classList.add('native-app')
  document.documentElement.classList.add(`native-${getNativePlatform()}`)

  try {
    await StatusBar.setStyle({ style: Style.Light })
    await StatusBar.setBackgroundColor({ color: '#00AEEF' })
  } catch {
    // Status bar styling is not available on every platform/simulator.
  }

  try {
    await Keyboard.setResizeMode({ mode: KeyboardResize.None })
    await Keyboard.setAccessoryBarVisible({ isVisible: false })
  } catch {
    // Keyboard plugin is iOS/Android only.
  }

  try {
    await SplashScreen.hide()
  } catch {
    // Splash may already be hidden.
  }

  // Must run before a bundle is downloaded or swapped, and before the rollback timeout.
  await markLiveUpdateReady()
}

export function attachNativeRuntime(onAppUrl: (path: string) => void): () => void {
  if (!isNativePlatform()) return () => undefined
  const detachLinks = interceptExternalLinks()
  const detachUrls = listenForAppUrlOpen(onAppUrl)
  return () => {
    detachLinks()
    detachUrls()
  }
}
